import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { Link } from 'react-router';
import ThemeModeMenu from 'v2/components/ThemeMode/ThemeModeMenu';
import LanguageMenu from './LanguageMenu';
import ProfileMenu from './ProfileMenu';

type TopbarMenu = 'profile' | 'language' | 'theme';

const Topbar = ({ toggleSidebar, showSidebar }: { toggleSidebar: () => void; showSidebar: boolean }) => {
  const { translation } = useTranslation();
  const [openMenu, setOpenMenu] = React.useState<TopbarMenu | null>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isOpen = (menu: TopbarMenu) => !!anchorEl && menu === openMenu;

  const handleOpen = (menu: TopbarMenu) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenMenu(menu);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={(theme) => ({
        background: theme.custom.background.level1,
        borderBottom: '1px solid',
        borderColor: theme.palette.primary.main
      })}
    >
      <Toolbar>
        {showSidebar && (
          <IconButton
            id="open-sidebar-button"
            color="inherit"
            aria-label={translation.open_menu}
            onClick={toggleSidebar}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Link id="home-link" to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Typography id="title" variant="h6" noWrap color="primary">
            ATLAS
          </Typography>
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <LanguageMenu
          anchorEl={anchorEl}
          open={isOpen('language')}
          onOpen={handleOpen('language')}
          onClose={handleClose}
        />
        <ThemeModeMenu anchorEl={anchorEl} open={isOpen('theme')} onOpen={handleOpen('theme')} onClose={handleClose} />
        <ProfileMenu
          anchorEl={anchorEl}
          open={isOpen('profile')}
          onOpen={handleOpen('profile')}
          onClose={handleClose}
        />
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
